export default __webpack_public_path__ + "static/media/slothity.8125e35c.png";